<script lang="ts" setup>
import SupportCall from '@/components/Header/HeaderNavigationDrawer/SupportCall.vue'
</script>

<template>
  <div class="support-dialog">
    <h2 class="support-dialog__title">Связаться с поддержкой</h2>

    <h3 class="support-dialog__headline">
      Выберите удобный для вас способ связи
    </h3>

    <support-call />
  </div>
</template>

<style lang="scss" scoped>
.support-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  &__title {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 800;
    color: var(--ui-text-primary);
    text-align: center;
  }

  &__headline {
    width: 80%;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 600;
    color: var(--ui-text-primary);
    text-align: center;
  }
}
</style>
